import api from './api';
import { 
  NotesResponse, 
  NoteResponse, 
  NoteFormData, 
  LeadsResponse 
} from '../types/Note';

export const noteApi = {
  // Get all notes with pagination and filters
  getNotes: async (
    page: number = 1, 
    limit: number = 20, 
    search: string = '',
    leadId: string = ''
  ): Promise<NotesResponse> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(leadId && { leadId })
    });

    const response = await api.get(`/notes?${params}`);
    return response.data;
  },

  // Get note by ID
  getNoteById: async (id: number): Promise<NoteResponse> => {
    const response = await api.get(`/notes/${id}`);
    return response.data;
  },

  // Create new note
  createNote: async (noteData: NoteFormData): Promise<NoteResponse> => {
    const response = await api.post('/notes', noteData);
    return response.data;
  },

  // Update note
  updateNote: async (id: number, noteData: Partial<NoteFormData>): Promise<NoteResponse> => {
    const response = await api.put(`/notes/${id}`, noteData);
    return response.data;
  },

  // Delete note
  deleteNote: async (id: number): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/notes/${id}`);
    return response.data;
  },

  // Get notes by lead ID
  getNotesByLeadId: async (leadId: number): Promise<NotesResponse> => {
    const response = await api.get(`/notes/lead/${leadId}`);
    return response.data;
  },

  // Get notes by task ID
  getNotesByTaskId: async (taskId: number): Promise<NotesResponse> => {
    const params = new URLSearchParams({
      page: '1',
      limit: '100', // Get all notes for the task
      taskId: taskId.toString()
    });
    const response = await api.get(`/notes?${params}`);
    return response.data;
  },

  // Get leads for note assignment (searchable)
  getLeads: async (search: string = ''): Promise<LeadsResponse> => {
    const params = new URLSearchParams();
    if (search) {
      params.append('search', search);
    }

    const response = await api.get(`/notes/leads/search?${params}`);
    return response.data;
  },
};
